import { Button } from './button';

export class ButtonClickedEvent {
    constructor(public button: Button, public entity?: any) {}
}
